/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "es";
export const localeOptions = [
  { id: "en", name: "English", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
];

export const firebaseConfig = {
  apiKey: "AIzaSyAEroUDKzRuCkEiHVvyQN1IxexnplQcw_g",
  authDomain: "aet-chat.firebaseapp.com",
  databaseURL: "https://aet-chat.firebaseio.com",
  projectId: "aet-chat",
  storageBucket: "aet-chat.appspot.com",
  messagingSenderId: "219536029160",
  appId: "1:219536029160:web:cd866ab65679429756a05d"
};

export const searchPath = "/app/pages/search";
export const servicePath = "https://www2.pcrecruiter.net/rest/api";
// http://aetprueba.outhelping.com.mx:5330/php/   http://localhost:8888/aet-php/
export const notificationUrl = "http://aetprueba.outhelping.com.mx:5330/php/";

export const DatabaseId = "Outhelping SC.outhelpingsc";
export const Username = "FTELLEZ";
export const Password = "OH*RH2022";
export const AppId = "4597911d";
export const ApiKey = "258478404e9d3b2623b4caa983f60a31";

export const themeColorStorageKey="__theme_color"
export const isMultiColorActive = true;
export const defaultColor = "light.purple";
export const isDarkSwitchActive = true;
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const isDemo = false;
